module.exports = __webpack_public_path__ + "img/pesta.efeaa02b.png";